module.exports = __webpack_public_path__ + "media/images/payment-providers/bitcoin-e9fa7b725d02645b4cc42f9dd487e19f.svg";